var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.isLoading
    ? _c(
        "div",
        { staticClass: "page-loading" },
        [
          _c("b-loading", {
            attrs: { active: _vm.isLoading, "is-full-page": "" },
            on: {
              "update:active": function ($event) {
                _vm.isLoading = $event
              },
            },
          }),
        ],
        1
      )
    : _c("div", { staticClass: "declaration-page" }, [
        _c("div", { staticClass: "page-topbar" }, [_c("language-switcher")], 1),
        !_vm.errorMessage
          ? _c("div", { staticClass: "page-body" }, [
              _c("div", { staticClass: "declaration-hero" }, [
                _c("h1", { staticClass: "declaration-hero__title" }, [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.$t("consignee.consignee_declaration.welcome")
                      ) +
                      " "
                  ),
                ]),
                _c("p", { staticClass: "declaration-hero__name" }, [
                  _vm._v(_vm._s(_vm.declaration_mail.enduserName)),
                ]),
                _c("p", { staticClass: "declaration-hero__address" }, [
                  _vm._v(
                    " " +
                      _vm._s(
                        [
                          _vm.declaration_mail.address,
                          _vm.declaration_mail.city,
                          _vm.declaration_mail.country,
                          _vm.declaration_mail.postalCode,
                        ]
                          .filter(Boolean)
                          .join(" ")
                      ) +
                      " "
                  ),
                ]),
              ]),
              _c(
                "div",
                { staticClass: "has-text-centered mt-5 mb-4" },
                [
                  _c(
                    "b-button",
                    {
                      attrs: { type: "is-info", "icon-left": "download" },
                      on: { click: _vm.downloadPDF },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.$t(
                              "consignee.consignee_declaration.crates_identification"
                            )
                          ) +
                          " "
                      ),
                    ]
                  ),
                ],
                1
              ),
              !_vm.submited
                ? _c(
                    "div",
                    { staticClass: "declaration-form-wrap" },
                    [
                      _c("ValidationObserver", {
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function ({ invalid }) {
                                return [
                                  _c(
                                    "h2",
                                    {
                                      staticClass: "declaration-section-title",
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$t(
                                              "consignee.consignee_declaration.title"
                                            )
                                          ) +
                                          " "
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "p",
                                    { staticClass: "declaration-section-sub" },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$t(
                                              "consignee.consignee_declaration.sub-title"
                                            )
                                          ) +
                                          " "
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "div",
                                    { staticClass: "material-grid" },
                                    _vm._l(
                                      _vm.declarationQuantities,
                                      function (dc) {
                                        return _c(
                                          "div",
                                          {
                                            key: dc.material,
                                            staticClass: "material-card",
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "material-card__header",
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "material-card__name",
                                                  },
                                                  [_vm._v(_vm._s(dc.material))]
                                                ),
                                                dc.material === "GPS52" ||
                                                dc.material === "GPS55"
                                                  ? _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "material-card__info",
                                                      },
                                                      [
                                                        _c(
                                                          "b-tooltip",
                                                          {
                                                            attrs: {
                                                              position:
                                                                "is-bottom",
                                                              multilined: "",
                                                            },
                                                            scopedSlots: _vm._u(
                                                              [
                                                                {
                                                                  key: "content",
                                                                  fn: function () {
                                                                    return [
                                                                      _c(
                                                                        "b-image",
                                                                        {
                                                                          attrs:
                                                                            {
                                                                              src: _vm.getImgSrc(
                                                                                dc.material
                                                                              ),
                                                                              alt: `${dc.material} note`,
                                                                            },
                                                                        }
                                                                      ),
                                                                      _c(
                                                                        "strong",
                                                                        [
                                                                          _vm._v(
                                                                            "Click to see more"
                                                                          ),
                                                                        ]
                                                                      ),
                                                                    ]
                                                                  },
                                                                  proxy: true,
                                                                },
                                                              ],
                                                              null,
                                                              true
                                                            ),
                                                          },
                                                          [
                                                            _c("b-button", {
                                                              attrs: {
                                                                "icon-left":
                                                                  "info-circle",
                                                                type: "is-primary",
                                                                size: "is-small",
                                                                rounded: "",
                                                              },
                                                              on: {
                                                                click:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.showModal(
                                                                      dc.material
                                                                    )
                                                                  },
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                      ],
                                                      1
                                                    )
                                                  : _vm._e(),
                                              ]
                                            ),
                                            _vm.matLibelles &&
                                            _vm.matLibelles.find(
                                              (row) => row.MATNR === dc.material
                                            )
                                              ? _c(
                                                  "p",
                                                  {
                                                    staticClass:
                                                      "material-card__label",
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          _vm.matLibelles.find(
                                                            (row) =>
                                                              row.MATNR ===
                                                              dc.material
                                                          ).MAKTX
                                                        ) +
                                                        " "
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                            _c("ValidationProvider", {
                                              attrs: {
                                                slim: "",
                                                rules: {
                                                  required: true,
                                                  maxInput: true,
                                                  minInput: true,
                                                },
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "default",
                                                    fn: function ({ errors }) {
                                                      return [
                                                        _c("b-input", {
                                                          attrs: {
                                                            min: "0",
                                                            name:
                                                              "quantity" +
                                                              dc.material,
                                                            type: "number",
                                                          },
                                                          model: {
                                                            value: dc.quantity,
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                dc,
                                                                "quantity",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "dc.quantity",
                                                          },
                                                        }),
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "has-text-danger is-size-7",
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(errors[0])
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    },
                                                  },
                                                ],
                                                null,
                                                true
                                              ),
                                            }),
                                          ],
                                          1
                                        )
                                      }
                                    ),
                                    0
                                  ),
                                  _c(
                                    "b-modal",
                                    {
                                      attrs: { active: _vm.isModalVisible },
                                      on: {
                                        "update:active": function ($event) {
                                          _vm.isModalVisible = $event
                                        },
                                        close: _vm.hideModal,
                                      },
                                    },
                                    [
                                      _c("p", { staticClass: "image" }, [
                                        _c("img", {
                                          attrs: {
                                            src: _vm.getImgSrc(
                                              _vm.currentMaterial
                                            ),
                                          },
                                        }),
                                      ]),
                                    ]
                                  ),
                                  _c(
                                    "div",
                                    { staticClass: "declaration-field" },
                                    [
                                      _c(
                                        "label",
                                        {
                                          staticClass:
                                            "declaration-field__label",
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.$t(
                                                  "consignee.consignee_declaration.comment"
                                                )
                                              ) +
                                              " "
                                          ),
                                        ]
                                      ),
                                      _c("textarea", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.declaration.comments,
                                            expression: "declaration.comments",
                                          },
                                        ],
                                        staticClass: "textarea",
                                        attrs: { rows: "3" },
                                        domProps: {
                                          value: _vm.declaration.comments,
                                        },
                                        on: {
                                          input: function ($event) {
                                            if ($event.target.composing) return
                                            _vm.$set(
                                              _vm.declaration,
                                              "comments",
                                              $event.target.value
                                            )
                                          },
                                        },
                                      }),
                                    ]
                                  ),
                                  _c(
                                    "div",
                                    { staticClass: "declaration-field" },
                                    [
                                      _c(
                                        "label",
                                        {
                                          staticClass:
                                            "declaration-field__label",
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.$t(
                                                  "consignee.consignee_declaration.identity"
                                                )
                                              ) +
                                              " "
                                          ),
                                        ]
                                      ),
                                      _c("ValidationProvider", {
                                        attrs: {
                                          slim: "",
                                          rules: { required: true },
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function ({ errors }) {
                                                return [
                                                  _c("b-input", {
                                                    attrs: { name: "identity" },
                                                    model: {
                                                      value:
                                                        _vm.declaration
                                                          .identity,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.declaration,
                                                          "identity",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "declaration.identity",
                                                    },
                                                  }),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "has-text-danger is-size-7",
                                                    },
                                                    [_vm._v(_vm._s(errors[0]))]
                                                  ),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          true
                                        ),
                                      }),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "has-text-centered mt-5 mb-6",
                                    },
                                    [
                                      _c(
                                        "button",
                                        {
                                          staticClass:
                                            "button is-primary is-medium",
                                          attrs: { disabled: invalid },
                                          on: { click: _vm.submit },
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.$t(
                                                  "consignee.consignee_declaration.submit"
                                                )
                                              ) +
                                              " "
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          283167383
                        ),
                      }),
                    ],
                    1
                  )
                : _c("div", { staticClass: "declaration-success" }, [
                    _c("h1", { staticClass: "has-text-primary title is-4" }, [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.$t(
                              "consignee.consignee_declaration.declaration_sent.title"
                            )
                          ) +
                          " "
                      ),
                    ]),
                    _c("p", [
                      _vm._v(
                        _vm._s(
                          _vm.$t(
                            "consignee.consignee_declaration.declaration_sent.content1"
                          )
                        )
                      ),
                    ]),
                    _c("div", { staticClass: "mt-5" }, [
                      _c(
                        "button",
                        {
                          staticClass: "button is-info",
                          class: { "is-loading": _vm.downloadingPdf },
                          on: {
                            click: function ($event) {
                              return _vm.getPdfReport()
                            },
                          },
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$t(
                                  "consignee.consignee_declaration.declaration_sent.download_declaration"
                                )
                              ) +
                              " "
                          ),
                        ]
                      ),
                    ]),
                  ]),
            ])
          : _c("div", { staticClass: "page-body" }, [
              !_vm.askedNewMail
                ? _c("div", [
                    _c("div", { staticClass: "declaration-hero is-danger" }, [
                      _vm.declaration_mail && _vm.declaration_mail.declarationId
                        ? _c("h1", { staticClass: "declaration-hero__title" }, [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$t(
                                    "consignee.consignee_declaration.token_used"
                                  )
                                ) +
                                " "
                            ),
                          ])
                        : _c("h1", { staticClass: "declaration-hero__title" }, [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$t(
                                    "consignee.consignee_declaration.something_went_wrong"
                                  )
                                ) +
                                " "
                            ),
                          ]),
                    ]),
                    _c("div", { staticClass: "declaration-error-body" }, [
                      !(
                        _vm.declaration_mail &&
                        _vm.declaration_mail.declarationId
                      )
                        ? _c("p", [_vm._v(_vm._s(_vm.errorMessage))])
                        : _vm._e(),
                      _vm.invalidToken
                        ? _c("div", { staticClass: "mt-4" }, [
                            _vm.declaration_mail &&
                            _vm.declaration_mail.declarationId
                              ? _c("p", [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t(
                                          "consignee.consignee_declaration.token_used_message"
                                        )
                                      ) +
                                      " "
                                  ),
                                ])
                              : _c("p", [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t(
                                          "consignee.consignee_declaration.ask_new_mail_message"
                                        )
                                      ) +
                                      " "
                                  ),
                                ]),
                            _c("div", { staticClass: "mt-4" }, [
                              _c(
                                "button",
                                {
                                  staticClass: "button is-info",
                                  on: { click: _vm.askNewMail },
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t(
                                          "consignee.consignee_declaration.ask_new_mail_button"
                                        )
                                      ) +
                                      " "
                                  ),
                                ]
                              ),
                            ]),
                          ])
                        : _vm._e(),
                    ]),
                  ])
                : _c("div", [
                    _c("div", { staticClass: "declaration-hero" }, [
                      _c("h1", { staticClass: "declaration-hero__title" }, [
                        _vm._v(_vm._s(_vm.$t("global.success"))),
                      ]),
                    ]),
                    _c("div", { staticClass: "declaration-error-body" }, [
                      _c("p", [
                        _vm._v(
                          _vm._s(
                            _vm.$t(
                              "consignee.consignee_declaration.new_email_sent"
                            )
                          )
                        ),
                      ]),
                    ]),
                  ]),
            ]),
      ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }